import { NgModule  } from '@angular/core';

import { SharedModule }                   from '../../app-lite/shared/shared.module';
import { VehicleActionsComponent }        from './vehicle.actions.component';
import { VehicleHistoryActionsComponent } from './vehicle.imported-history.actions.component';

@NgModule({
    declarations: [
        VehicleActionsComponent,
        VehicleHistoryActionsComponent
    ],
    entryComponents: [
        VehicleActionsComponent,
        VehicleHistoryActionsComponent
    ],
    imports: [
        SharedModule
    ]
})
export class VehiclesModule {}